<script lang="tsx">
import { defineComponent, reactive, toRefs } from 'vue'
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage } from 'element-plus'

import { Node, Graph, StringExt } from '@antv/x6'
import addPlus from '@/assets/images/add-plus.png'
import { notDelCell, approvalRangeLevels } from '@/enums/flow'
import { defaultNode } from '@/components/business/FlowSetting/defaultData'
type PositionType = 'top' | 'bottom'
// 节点位置信息
interface Position {
  x: number
  y: number
}
const props = {
  node: {
    type: Node
  }
}
const positiom = [
  {
    key: 'top',
    value: '0'
  },
  {
    key: 'bottom',
    value: '3'
  }
]
const flowConfig = [
  {
    icon: 'document',
    name: '审批节点',
    type: 'APPROVAL'
  }
]
const itemContent = () => (
  <div class="dropWrap">
    <ElDropdownMenu>
      {flowConfig.map(item => (
        <ElDropdownItem command={item.type} key={item.type}>
          <i class={`iconfont icon-${item.icon}`} /> {item.name}
        </ElDropdownItem>
      ))}
    </ElDropdownMenu>
  </div>
)
const calculateNewNodePosition = (graph, node, type, dy = 60) => {
  const { x, y } = node.getPosition()
  const { height } = node.size()
  if (type === '0') {
    return { x, y: y - height - dy }
  } else {
    return { x, y: y + height + dy }
  }
}
export default defineComponent({
  name: 'FlowCmp',
  props,
  setup(props) {
    const { node } = props
    let flowData = reactive({ current: node.getData() })
    node.on('change:data', e => {
      flowData.current = e.current
    })
    const onMainMouseEnter = () => {
      const { node } = props
      const ports = node.getPorts() || []
      ports.forEach(port => {
        node.setPortProp(port.id, 'attrs/circle', {
          fill: '#fff',
          stroke: '#85A5FF'
        })
      })
    }
    const onMainMouseLeave = () => {
      const { node } = props
      const ports = node.getPorts() || []
      ports.forEach(port => {
        node.setPortProp(port.id, 'attrs/circle', {
          fill: 'transparent',
          stroke: 'transparent'
        })
      })
    }
    /**
     * 创建节点
     * @param graph
     * @param position 节点位置
     * @returns
     */
    const createNode = (graph: Graph, position: Position, command: string) => {
      if (!graph) {
        return {}
      }
      let newNode = {}
      const id = StringExt.uuid()
      const node = {
        id,
        shape: 'flow-approval-comp',
        x: position?.x + 100,
        y: position?.y,
        ports: getPorts(id),
        data: {
          ...flowConfig.find(flow => flow.type === command),
          ...defaultNode
        }
      }
      newNode = graph.addNode(node)
      return newNode
    }
    const getPorts = (id: string) => {
      return [
        { id: `${id}-top`, group: 'top' },
        { id: `${id}-bottom`, group: 'bottom' },
        { id: `${id}-left`, group: 'left' },
        { id: `${id}-right`, group: 'right' }
      ]
    }
    /**
     * 复制节点
     * @param graph
     * @param position
     * @param command
     */
    const copyNode = (graph: Graph, position: Position, node: Node | undefined = undefined) => {
      if (!graph) {
        return {}
      }
      let data = {}
      if (node?.getData()) {
        data = node?.getData()
      }
      let newNode = {}
      const id = StringExt.uuid()
      const copy = {
        id,
        shape: 'flow-approval-comp',
        x: position?.x,
        y: position?.y,
        ports: getPorts(id),
        data: {
          ...data
        }
      }
      newNode = graph.addNode(copy)
      return newNode
    }
    /**
     * 创建边
     * @param source
     * @param target
     * @param graph
     */
    const createEdge = (source: string, target: string, graph: Graph, type: PositionType) => {
      let oppositeV
      ;['left,right', 'top,bottom'].some(item => {
        const [s, e] = item.split(',')
        oppositeV = item.split(',').indexOf(type) ? s : e
        return item.includes(type)
      })
      const edge = {
        id: StringExt.uuid(),
        shape: 'customer-edge',
        source: {
          cell: source,
          port: `${target}-${type}`
        },
        target: {
          cell: target,
          port: `${target}-${oppositeV}`
        },
        zIndex: -1,
        data: {
          source,
          target
        }
      }
      if (graph) {
        graph.addEdge(edge)
      }
    }

    // 计算位置
    const getDownstreamNodePosition = (node: Node, graph: Graph, type: PositionType) => {
      return calculateNewNodePosition(graph, node, type)
    }
    const createDownstream = (command: any, type: any) => {
      const { node } = props
      const { graph } = node?.model || {}
      if (graph) {
        const position = getDownstreamNodePosition(node, graph, type)
        const newNode = createNode(graph, position, command)
        const source = node?.id || ''
        const target = newNode?.id
        createEdge(source, target, graph, type)
      }
    }
    //
    const handleDropDownClick = (command: string, key: PositionType) => {
      createDownstream(command, key)
    }
    const { current } = toRefs(flowData)
    const getApprover = (data: any) => {
      let str: any = '请选择审核人员'
      if (data.approver?.length) {
        const arr = data.approver
          .filter((el: any) => el.type !== 'DYNAMIC')
          .map((el: any) => el.name)
        const dynamic = data.approver.filter((el: any) => el.type === 'DYNAMIC') || []
        if (dynamic.length) {
          arr.push('动态配置')
        }
        str = arr.join(',')
      }
      if (data.levelApprovalRange) {
        const res = approvalRangeLevels.find((el: any) => el.value === data.levelApprovalRange)
        if (res) str = res?.label
      }
      return str
    }
    const copy = () => {
      const { node } = props
      const { graph } = node?.model || {}
      if (graph) {
        const position = getDownstreamNodePosition(node, graph, 'bottom')
        copyNode(graph, position, node)
      }
    }
    const close = () => {
      const { node } = props
      const { graph } = node?.model || {}
      if (graph) {
        let allNodes = graph!.getNodes()
        allNodes = allNodes.filter((cell: any) => {
          const { type } = cell.getData()
          return !notDelCell.includes(type) && cell.isNode()
        })
        if (allNodes.length === 1) {
          ElMessage({ message: '至少保留一个节点！', type: 'warning' })
        } else {
          ElMessageBox.confirm('是否确认删除选中节点？', '提示', {
            type: 'warning'
          }).then(() => {
            graph!.removeCells([node] as any)
          })
        }
      }
    }
    // <span>{current.value.label}</span>
    return () => (
      <div>
        <div
          class={`flow_wrap ${current.value.error ? 'flow_wrap__error' : ''}`}
          onMouseenter={onMainMouseEnter}
          onMouseleave={onMainMouseLeave}
        >
          <div class="flow_chat">
            <div
              class="node-name"
              style={{
                backgroundColor: current.value.type === 'APPROVAL' ? '#5687FF' : '#5DC144'
              }}
            >
              <span>{current.value.name || '请填写节点名称'}</span>
              <div class="close" onClick={close}>
                <span class="icon iconfont icon-close"></span>
              </div>
            </div>
            <div class="flow_approval_bottom">
              <div class="approval_wrap">{getApprover(current.value)}</div>
              <div class="approval_name">
                <i class={'iconfont icon icon-document'} onClick={copy} />
              </div>
            </div>
            {positiom.map((item: any) => (
              <ElDropdown
                placement="bottom-start"
                trigger="click"
                class={['dropdown', item.key]}
                key={item.key}
                style={{ [item.key]: 0 }}
                onCommand={e => handleDropDownClick(e, item.value)}
              >
                {{
                  default: () => (
                    <span class="el-dropdown-link">
                      <img class="add" src={addPlus} />
                    </span>
                  ),
                  dropdown: () => itemContent()
                }}
              </ElDropdown>
            ))}
          </div>
          <div class="flow-node-default-extent"></div>
        </div>
        <div class="approval_error">{current.value.error}</div>
      </div>
    )
  }
})
</script>
<style scoped lang="scss">
.approval_error {
  margin-top: 2px;
  font-size: 12px;
  color: #f34444;
}
.flow_wrap {
  cursor: move;
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 2px 5px 0 #00000014;
  border: 1px solid transparent;
  box-sizing: border-box;
  position: relative;
  &__error {
    box-shadow: 0 0 0 2px #fab5b5 !important;
    border: 1px solid #f34444 !important;
  }
  &:hover {
    box-shadow: 0 0 0 3px rgba(48, 129, 242, 0.2);
    border: 1px solid #5687ff;
    box-sizing: border-box;
  }
  .flow_chat {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .flow_approval_bottom {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 8px 12px;
      .approval_wrap {
        color: #5687ff;

        font-size: 12px;

        font-weight: 700;
        margin-bottom: 4px;
      }
      .approval_name {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 12px;
        color: #999;
        z-index: 999;
        height: 16px;
        .icon {
          color: #dedfe0;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    .dropdown {
      position: absolute;
      visibility: hidden;
      &.top {
        left: 50%;
        transform: translate(-50%, -120%);
      }
      &.bottom {
        left: 50%;
        transform: translate(-50%, 120%);
      }
      &.left {
        transform: translateX(-120%);
      }
      &.right {
        transform: translateX(120%);
      }
      .add {
        width: 14px;
        height: 14px;
      }
    }
  }
  .node-name {
    width: 100%;
    height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    box-sizing: border-box;
    color: #fff;
    background: #5687ff;
    line-height: 28px;
    font-size: 12px;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close {
      position: relative;
      height: 20px;
      width: 20px;
      font-size: 16px;
      z-index: 999;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      flex-shrink: 0;
    }
  }
  .flow-node-default-extent {
    bottom: -15px;
    left: -15px;
    // pointer-events: none;
    position: absolute;
    right: -15px;
    top: -15px;
  }
}
</style>
<style lang="scss">
.x6-edge:hover path:nth-child(2) {
  stroke: #1890ff;
  stroke-width: 1px;
}
.x6-edge-selected path:nth-child(2) {
  stroke: #1890ff;
  stroke-width: 1.5px !important;
}
.x6-node-selected {
  .flow_wrap {
    border: 1px solid #5687ff;
  }
  .dropdown {
    visibility: visible !important;
    z-index: 999;
    cursor: pointer;
  }
  .x6-port {
    visibility: hidden !important;
  }
}
.dropWrap {
  min-width: 132px;
  padding: 12px;
  box-sizing: border-box;
  .el-dropdown-menu {
    padding: 0;
    .el-dropdown-menu__item {
      padding: 0;
      display: flex;
      padding: 5px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 0.5px solid #dcdfe6;
      margin-bottom: 8px;
      color: #333333;
      font-size: 14px;
    }
    .el-dropdown-menu__item:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
